import React from "react";
import { mergeStyles, Stack } from "@fluentui/react";
import {
  stackTokens,
  styles,
} from "../ExperimentDetailsForm/experimentDetailsForm.styles";

interface FormRowProps {
  children: React.ReactNode;
  horizontal?: boolean;
  className?: string;
  styles?: React.CSSProperties;
  "data-testid"?: string;
}

const FormRow: React.FC<FormRowProps> = ({
  children,
  horizontal = false,
  className,
  styles: customStyles,
  "data-testid": dataTestId,
}) => {
  return (
    <Stack
      horizontal={horizontal}
      tokens={stackTokens}
      style={customStyles}
      className={mergeStyles(styles.experimentDetailsFormRow, className)}
      data-testid={dataTestId}
    >
      {children}
    </Stack>
  );
};

export default FormRow;
